// Single source of truth for the chart series palette. Imported by both the
// uplot preset (presets/usage.js) and the chartjs renderer (chart.js/Chart.js)
// so a multi-series chart picks the same color regardless of which engine
// renders it.

export const PALETTE = [
  "#6366f1",
  "#0ea5e9",
  "#10b981",
  "#f59e0b",
  "#8b5cf6",
  "#ef4444",
  "#ec4899",
  "#14b8a6",
];

export function seriesColor(idx) {
  return PALETTE[idx % PALETTE.length];
}
